<script>
export default {
  name: 'Empty',
}
</script>


<template>
    <div>
        
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

</style>
